import { apiInstance } from '@diamond/shared/utils';

export const reorderBanner = async (
  token: string,
  id: string,
  index: number
) => {
  return await apiInstance(token).patch(
    `/backoffice/banner/${id}/reorder`,
    JSON.stringify({ index })
  );
};
